import ColorHash from 'color-hash';

interface ProfileAvatarProps {
    name: string;
    size?: number;
}

export function ProfileAvatar({ name, size = 18 }: Readonly<ProfileAvatarProps>) {
    const colorHash = new ColorHash({ lightness: 0.9 });
    const colour = colorHash.hex(name).replace('#', '');
    const url = `https://ui-avatars.com/api/?background=${colour}&name=${encodeURIComponent(name)}&rounded=true&size=${size * 2}`;
    return <img src={url} alt={name} height={size} width={size} />;
}
